import {
  BarChart,
  Settings,
  PermIdentity,
  Lock,
  Group,
  MenuBook,
  DeviceHub,
  Bookmarks,
  Assignment,
  List,
  Edit,
  AddAlert,
  Sailing,
  YoutubeSearchedFor,
  Summarize,
  Notifications,
  GroupWork,
  PeopleOutline,
  ConnectWithoutContact,
} from '@mui/icons-material';

// 基本資料
import Page_BasicInfo from '~/containers/Page_Main/Page_InfoManagement/Page_BasicInfo';
// 行政契約
import Page_Contract from '~/containers/Page_Main/Page_InfoManagement/Page_Admin/Page_Contract';// 契約內容
import Page_AdminProgram from '~/containers/Page_Main/Page_InfoManagement/Page_Admin/Page_AdminProgram';// 行政程序
import Page_Finance from '~/containers/Page_Main/Page_InfoManagement/Page_Admin/Page_Finance';// 金融項目
import Page_Equity from '~/containers/Page_Main/Page_InfoManagement/Page_Admin/Page_Equity';// 股權架構
import Page_Extend from '~/containers/Page_Main/Page_InfoManagement/Page_Admin/Page_Extend';// 展延資訊
// 碼頭系統
import Page_PierSystem from '~/containers/Page_Main/Page_InfoManagement/Page_PierSystem';
// 工程進度
import Page_ProjectProgress from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_ProjectProgress';// 工進
import Page_PPDaily from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_PPDaily';// 每日進度
import Page_PPFan from '~/containers/Page_Main/Page_InfoManagement/Page_ProjectProgress/Page_PPFan';// 風機點位
// 船舶資訊
import Page_NativeBoat from '~/containers/Page_Main/Page_InfoManagement/Page_BoatInfo/Page_NativeBoat';// 國內船舶
import Page_ForeignBoat from '~/containers/Page_Main/Page_InfoManagement/Page_BoatInfo/Page_ForeignBoat';// 國外船舶
// 產業關聯
import Page_IAOverview from '~/containers/Page_Main/Page_InfoManagement/Page_IndustryAssociation/Page_IAOverview';// 總覽
import Page_IAMeet from '~/containers/Page_Main/Page_InfoManagement/Page_IndustryAssociation/Page_IAMeet';// 相關會議與函文
// 工程進度追蹤
import Page_PPTrackForm from '~/containers/Page_Main/Page_InfoManagement/Page_PPTrack/Page_PPTrackSheet';// 工程進度追蹤表
import Page_PPTrackManagement from '~/containers/Page_Main/Page_InfoManagement/Page_PPTrack/Page_PPTrackManagement';// 工程進度追蹤管理
// 事件提醒管理
import Page_EventNotificationManagement from '~/containers/Page_Main/Page_InfoManagement/Page_EventNotification/Page_EventNotificationManagement';


// 帳號管理
import Page_UserAccountManagement from '~/containers/Page_Main/Page_SystemManagement/Page_UserAccountManagement';
import Page_PersonalManagement from '~/containers/Page_Main/Page_SystemManagement/Page_PersonalManagement';
// 組織管理
import Page_OrgManagement from '~/containers/Page_Main/Page_SystemManagement/Page_OrgManagement';
// 權限管理
import Page_AtyManagement from '~/containers/Page_Main/Page_SystemManagement/Page_AtyManagement';
// 風場合約管理
import Page_WindManagement from '~/containers/Page_Main/Page_SystemManagement/Page_WindManagement';
// 群組管理
import Page_GroupManagement from '~/containers/Page_Main/Page_SystemManagement/Page_GroupManagement';
// 帳號清查管理
import Page_InventoryManagement from '~/containers/Page_Main/Page_SystemManagement/Page_InventoryManagement';
import Page_NotifyMail from '~/containers/Page_Main/Page_SystemManagement/Page_NotifyMail';
// 日誌管理
import Page_NoteManagement from '~/containers/Page_Main/Page_SystemManagement/Page_NoteManagement';
// 報表管理
import Page_ReportManagement from '~/containers/Page_Main/Page_SystemManagement/Page_ReportManagement';
import Blank from '~/components/Blank';
// 提醒功能
import Page_Notification_Admin_Program from '~/containers/Page_Main/Page_SystemManagement/Page_Notification/Page_Notification_Admin_Program';
import Page_Notification_Work_Progress from '~/containers/Page_Main/Page_SystemManagement/Page_Notification/Page_Notification_Work_Progress';

export default [
  {
    text: '資料管理服務',
    icon: BarChart,
    path: 'data',
    detail: [
      {
        text: '基本資料檢視',
        icon: Assignment,
        detail: [],
        path: 'basic_contract_view',
        page: Page_BasicInfo,
      },
      {
        text: '行政契約',
        icon: List,
        detail: [
          {
            text: '契約內容',
            path: 'contract_content',
            page: Page_Contract,
          },
          {
            text: '行政程序',
            path: 'administrative_process',
            page: Page_AdminProgram,
          },
          {
            text: '金融項目',
            path: 'finance_item',
            page: Page_Finance,
          },
          {
            text: '股權架構',
            path: 'shareholding_structure',
            page: Page_Equity,
          },
          {
            text: '展延資訊',
            path: 'extension_information',
            page: Page_Extend,
          },
        ],
        path: 'administrative_contract',
        page: null,
      },
      {
        text: '碼頭系統',
        icon: Edit,
        detail: [],
        path: 'port_system',
        page: Page_PierSystem,
      },
      {
        text: '工程進度',
        icon: AddAlert,
        detail: [
          {
            text: '工程進度',
            path: 'work_progress',
            page: Page_ProjectProgress,
          },
          {
            text: '每日進度',
            path: 'daily_progress',
            page: Page_PPDaily,
          },
          {
            text: '風機點位工進',
            path: 'fan_point_work',
            page: Page_PPFan,
          },
        ],
        path: 'works_progress',
        page: null,
      },
      {
        text: '船舶資訊',
        icon: Sailing,
        detail: [
          {
            text: '本國船舶',
            path: 'domestic_boat',
            page: Page_NativeBoat,
          },
          {
            text: '外籍船舶',
            path: 'foreign_boat',
            page: Page_ForeignBoat,
          },
        ],
        path: 'boat_information',
        page: null,
      },
      {
        text: '產業關聯',
        icon: YoutubeSearchedFor,
        detail: [
          {
            text: '總覽',
            path: 'overview',
            page: Page_IAOverview,
          },
          {
            text: '相關會議與函文',
            path: 'related_meeting_correspondence',
            page: Page_IAMeet,
          },
        ],
        path: 'relationship_industry',
        page: null,
      },
      {
        text: '工程進度追蹤',
        icon: AddAlert,
        detail: [
          {
            text: '工程進度追蹤表',
            path: 'pp_track_sheet',
            page: Page_PPTrackForm,
          },
          {
            text: '工程進度追蹤管理',
            path: 'pp_track_management',
            page: Page_PPTrackManagement,
          },
        ],
        path: 'pp_track',
        page: null,
      },
      {
        text: '事件提醒管理',
        icon: Notifications,
        detail: [
          {
            text: '事件提醒管理',
            path: 'pp_event_notification_management',
            page: Page_EventNotificationManagement,
          },
        ],
        path: 'pp_event_notification',
        page: null,
      },
    ],
  },
  {
    text: '系統管理',
    icon: Settings,
    path: 'system',
    detail: [
      {
        text: '帳號管理',
        icon: PermIdentity,
        detail: [
          {
            text: '使用者維護管理',
            path: 'account_manager',
            page: Page_UserAccountManagement,
          },
          {
            text: '個人資料維護管理',
            path: 'personal_account_manager',
            page: Page_PersonalManagement,
          },
        ],
        path: 'account',
      },
      {
        text: '組織管理',
        icon: DeviceHub,
        detail: [],
        path: 'organization_manager',
        page: Page_OrgManagement,
      },
      {
        text: '權限管理',
        icon: Lock,
        detail: [],
        path: 'privilege_manager',
        page: Page_AtyManagement,
      },
      {
        text: '風場合約管理',
        icon: Bookmarks,
        detail: [],
        path: 'wind_contract_manager',
        page: Page_WindManagement,
      },
      {
        text: '群組管理',
        icon: ConnectWithoutContact,
        detail: [],
        path: 'group_manager',
        page: Page_GroupManagement,
      },
      {
        text: '帳號清查管理',
        icon: Group,
        detail: [
          {
            text: '清查作業',
            path: 'user_check_manager',
            page: Page_InventoryManagement,
          },
          {
            text: '通知信維護',
            path: 'message_manager',
            page: Page_NotifyMail,
          },
        ],
        path: 'user_check',
      },
      {
        text: '日誌管理',
        icon: MenuBook,
        detail: [],
        path: 'active_log_manager',
        page: Page_NoteManagement,
      },
      {
        text: '報表管理',
        icon: Summarize,
        detail: [],
        path: 'work_report_manager',
        // page: Blank,
        page: Page_ReportManagement,
      },
      {
        text: '提醒功能',
        icon: Notifications,
        detail: [
          {
            text: '行政程序',
            path: 'notification_admin_program',
            page: Page_Notification_Admin_Program,
          },
          {
            text: '工程進度',
            path: 'notification_work_progress',
            page: Page_Notification_Work_Progress,
          },
        ],
        path: 'notification',
      },
    ],
  },
];
